/*
 * HomePage
 *
 * This is the first thing users see of our App, at the '/' route
 *
 */

import React from 'react';
import { Footer } from '../../features/footer/Footer';
import { Header } from '../../features/header/Header';
import { Container, Row, Col, Button } from 'reactstrap';

import styled from 'styled-components';

const Hero = styled.div`
  position: relative;
`;

const ContactButton = styled(Button)`
  font-size: 18px;
  margin-top: 2em;
  margin-bottom: 2em;
`;

/* teal-color: rgb(0, 255, 255);
$brand-blue-color: 
$brand-mid-blue-color: rgb(4, 95, 176);
$brand-dark-blue-color: rgb(0, 0, 96) */

const HeroBody = styled.div`
  padding: 90px 0px;
  background-image: linear-gradient(45deg, rgb(4, 95, 176), rgb(0, 255, 255));
  color: white;
`;

const HeroH1 = styled.h1`
  margin-top: 0;
  font-size: 42px;
`;

const HeroH1Strong = styled.h1`
  margin-top: 0;
  font-size: 72px;
`;

const TPIcapEndorsement = styled.div`
  padding: 1rem;
  background: white;
`;

const Description = styled.div`
  margin-top: 1rem;
`;

// width: 50%;
// height: calc((100% + 92px) / 2);
const OrangeSection = styled.div`
  position: absolute;
  height: 100%;
  width: 35%;
  bottom: 0;
  right: 0;
  clip-path: url(#orange-section);
  transform: scaleY(-1);
`;

const OrangeSectionSvg = styled.svg`
  height: 100%;
  width: 100%;
`;

function NotFoundPage(props) {
  return (
    <>
      <Header />
      <Hero>
        <HeroBody>
          <Container>
            <Row>
              <Col md="8">
                <HeroH1>SOMETHING WENT WRONG</HeroH1>
                <HeroH1Strong>404</HeroH1Strong>
              </Col>
              <Col />
            </Row>
          </Container>
        </HeroBody>
        <TPIcapEndorsement>
          <Container>
            <Row>
              <Col md="8">
                <Description>
                  <h2>
                    WE’RE SORRY, BUT THE PAGE YOU’RE LOOKING FOR CAN’T BE FOUND.
                  </h2>
                  <h3>
                    If you entered a web address please check it was correct. Or
                    maybe you followed a link to a page that we've removed.
                  </h3>
                  <ContactButton
                    color="primary"
                    href="mailto:ParametaSupport@tpicap.com?Subject=Update%20My%20Account%20Details"
                  >
                    GET IN TOUCH
                  </ContactButton>
                </Description>
              </Col>
              <Col />
            </Row>
          </Container>
          <OrangeSection>
            <OrangeSectionSvg xmlns="http://www.w3.org/2000/svg" fill="red">
              <linearGradient
                id="parameta-orange"
                gradientTransform="rotate(90)"
              >
                <stop offset="5%" stopColor="rgb(140,0,0)" />
                <stop offset="95%" stopColor="rgb(255,111,0)" />
              </linearGradient>
              <polygon
                points="0,0 388,388 4000,388 4000,0"
                fill="url(#parameta-orange)"
              />
            </OrangeSectionSvg>
          </OrangeSection>
        </TPIcapEndorsement>
      </Hero>
      <Footer shape={false} />
    </>
  );
}

export default NotFoundPage;
